import { render, staticRenderFns } from "./RegisterConfirmationForm.vue?vue&type=template&id=23944326&scoped=true"
import script from "./RegisterConfirmationForm.vue?vue&type=script&lang=js"
export * from "./RegisterConfirmationForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterConfirmationForm.vue?vue&type=style&index=0&id=23944326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23944326",
  null
  
)

export default component.exports